/** Only same-origin paths are followed after sign-in; anything else lands on the dashboard. */
export function safeRedirect(target: string | undefined): string {
  return target !== undefined && target.startsWith("/") && !target.startsWith("//")
    ? target
    : "/app";
}
